import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import TextInput from '__components/Inputs/TextInput';
import TextTemplater, {
  type TextTemplaterProps,
} from 'components/Kizen/TextTemplater';
import { useSendTextFormAccess } from '../../singleactions/StepContent';

type SendTextProps = {
  body: string;
  mergeFields: Required<TextTemplaterProps>['customize']['mergeFields'];
  name: string;
  onBodyChange: TextTemplaterProps['onSave'];
  onNameChange(value: string): void;
};

const Wrapper = styled.div`
  flex: 1;
  margin-top: 15px;
  margin-bottom: 17px;
`;

const SendText = (props: SendTextProps) => {
  const { body, mergeFields, name, onBodyChange, onNameChange } = props;

  const { t } = useTranslation();

  const { showForm, showTextWithLink, showGenericText } =
    useSendTextFormAccess();

  return (
    <Wrapper>
      {showForm && (
        <>
          <TextInput
            label={t('Name Your Broadcast')}
            placeholder={t('Enter Broadcast Name')}
            value={name}
            onChange={onNameChange}
          />
          <TextTemplater
            defaultValue={body}
            customize={{ mergeFields }}
            textareaOptions={{
              initialHeight: 140,
            }}
            onSave={onBodyChange}
          />
        </>
      )}
      {showTextWithLink && (
        <div>
          <KizenTypography as="span">
            {t(
              'A text messaging provider needs to be configured to send text messages. This can be done under '
            )}
          </KizenTypography>
          <KizenTypography
            type="anchor"
            href="/settings/privacy-settings"
            target="_blank"
          >
            {t('privacy settings.')}
          </KizenTypography>
        </div>
      )}
      {showGenericText && (
        <>
          <KizenTypography>
            {t(
              'A text messaging provider needs to be configured to send text messages. An administrator will need to set this up under Privacy Settings.'
            )}
          </KizenTypography>
        </>
      )}
    </Wrapper>
  );
};

export default SendText;
